var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-back-button"},[_c('p',{on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_vm._v("< "+_vm._s(_vm.$t('common.back')))])])}
var staticRenderFns = []

export { render, staticRenderFns }